import {
  faCashRegister,
  faFileLines,
  faGears,
  faReceipt
} from "@fortawesome/pro-light-svg-icons";
import { useNavigate } from "react-router-dom";

import { Tile, TileIcon } from "~/components/home/tile";
import { useT } from "@repo/transifex";
import { type Till } from "~/api/tills/types";

import { MainTile } from "./MainTile";
import { CashDrawerTile } from "./CashDrawerTile";

type HomeGridProps = {
  till: Till;
  isTillOpen: boolean;
  isSessionValid: boolean;
  hasCashDrawer: boolean;
};

export const HomeGrid = ({
  till,
  isTillOpen,
  isSessionValid,
  hasCashDrawer
}: HomeGridProps) => {
  const t = useT();
  const navigate = useNavigate();

  if (till.type === "collect-lite") {
    return (
      <div className="flex flex-1 flex-row gap-4 landscape:flex-col">
        <MainTile
          till={till}
          isTillOpen={isTillOpen}
          isSessionValid={isSessionValid}
        />
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-row gap-4 landscape:flex-col">
      <MainTile
        till={till}
        isTillOpen={isTillOpen}
        isSessionValid={isSessionValid}
      />

      <div className="flex h-auto w-64 flex-col gap-4 landscape:h-52 landscape:w-auto landscape:flex-row">
        {hasCashDrawer ? (
          <CashDrawerTile
            isTillOpen={isTillOpen}
            isSessionValid={isSessionValid}
          />
        ) : null}

        <Tile
          onClick={() => {
            navigate("/settings/reports");
          }}
          title={t("Reports")}
          className="flex-1"
        >
          <TileIcon icon={faFileLines} />
        </Tile>

        <Tile
          onClick={() => {
            navigate("/settings/transactions");
          }}
          title={t("Transactions")}
          className="flex-1"
        >
          <TileIcon icon={faReceipt} />
        </Tile>

        <Tile
          onClick={() => {
            navigate("/settings/tills");
          }}
          title={t("Till management")}
          warningIcon={!isSessionValid}
          className="flex-1"
        >
          <TileIcon icon={faCashRegister} />
        </Tile>

        <Tile
          onClick={() => {
            navigate("/settings/devices");
          }}
          title={t("Settings")}
          className="flex-1"
        >
          <TileIcon icon={faGears} />
        </Tile>
      </div>
    </div>
  );
};
